import { useEffect } from 'react';
import { supabase } from './supabase';

const FALLBACK_REFRESH_MS = 30000;
const REALTIME_DEBOUNCE_MS = 120;

export function reservationRealtimeFilter(restaurantId) {
  return `ristorante_id=eq.${restaurantId}`;
}

export default function useReservationRealtime(channelKey, restaurantId, onChange) {
  useEffect(() => {
    if (!restaurantId || typeof onChange !== 'function') return undefined;

    let refreshTimeoutId;
    const scheduleRefresh = () => {
      window.clearTimeout(refreshTimeoutId);
      refreshTimeoutId = window.setTimeout(() => onChange('realtime'), REALTIME_DEBOUNCE_MS);
    };

    const channel = supabase
      .channel(`reservation-changes:${channelKey}:${restaurantId}:${Date.now()}`)
      .on('postgres_changes', {
        event: '*',
        schema: 'public',
        table: 'recover_reservations',
        filter: reservationRealtimeFilter(restaurantId),
      }, scheduleRefresh)
      .subscribe();

    const fallbackId = window.setInterval(() => onChange('fallback'), FALLBACK_REFRESH_MS);

    return () => {
      window.clearTimeout(refreshTimeoutId);
      window.clearInterval(fallbackId);
      supabase.removeChannel(channel);
    };
  }, [channelKey, restaurantId, onChange]);
}

